import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateDiscountPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.createDiscountPerk,
  {
    mutationKey: ['createDiscountPerk'],
  },
)
